import {environment} from 'environments/environment';
import {StateService} from '@uirouter/angular';
import { AreaKey } from 'app/original-models/level-type.model';
import {BankAccountsService} from '../original-services/bank-accounts.service';
import {CompanyGroupService} from '../original-services/company-group.service';
import {LoggerService} from '../original-services/logger.service';
import {CompanyService} from '../original-services/company.service';
import {GroupService} from '../original-services/group.service';
import {StorageService} from '../original-services/storage.service';
import { IntercomService } from 'app/services/intercom/intercom.service';

export function SetupIntercomFactory(
    intercom: IntercomService,
    logger: LoggerService,
    stateService: StateService,
    storage: StorageService,
    bankAccountsService: BankAccountsService,
    companyService: CompanyService,
    companyGroupService: CompanyGroupService,
    groupService: GroupService
) {
    function getIntercomSettings(company: any): void {
        intercom.shutdown();
        setTimeout(() => {
            if (company) {
                companyGroupService.getIntercomSettings().subscribe({
                    next: settings => {
                        if (settings) {
                            intercom.initializeUser(settings.getIntercomModel(environment.intercom.appId, company.id, settings.isCompany));
                            logger.debug('Intercom initialized');
                        }
                    }, error: error => {
                        logger.error(error);
                    }
                });
            } else {
                intercom.boot();
            }
        }, 500);
    }

    return () => {
        let names = ['login', 'authorizeSlack', 'sign-in', 'sign-up', 'restore-email', 'restore-password', 'user-activate', 'new-password', 'activate'];
        let company;
        companyService.currentCompanyChanged$.subscribe({
            next: data => {
                let area = storage.getArea();
                let currentCompanyId = area.key === 'companies' ? area.id : null;
                if (data && data.id === currentCompanyId) {
                    setTimeout(() => {
                        company = data;
                        names.indexOf(stateService.current.name) < 0 || company ? getIntercomSettings(company) : intercom.shutdown();
                    }, 1000);
                }
            }, 
            error: error => {
                logger.error(error);
            }
        });

        //TODO: Do we need to reinitialize intercom on these events?
        bankAccountsService.onSyncTransactions().subscribe((data) => {
            if (data && data.status && data.status.toUpperCase() === 'SUCCESS') {
                getIntercomSettings(company);
            }
        });

        bankAccountsService.accountDeleted$.subscribe((data: boolean) => {
            if (data) {
                getIntercomSettings(company);
            }
        });
        let group;
        groupService.currentGroupChanged$.subscribe({
            next: data => {
                let area = storage.getArea();
                let currentGroupId =  area.key === AreaKey.Groups ? area.id : null;
                if (data && data.id === currentGroupId) {
                    setTimeout(() => {
                        group = data;
                        names.indexOf(stateService.current.name) < 0 || group ? getIntercomSettings(group) : intercom.shutdown();
                    }, 1000);
                }
            }, error: error => {
                logger.error(error);
            }
        });
    }
}
